export const manualJobQueryParams = ({ username }) => ({
  username,
  manual_only: true,
  full: true,
});
